export default __webpack_public_path__ + "static/media/em.6ae5e315.svg";